import * as React from 'react';
import { ellipsis } from '../../../_common/Ellipsis/Ellipsis';

interface ProductListItemNameProps {
  text: string;
  isVerticallyCentered: boolean;
}

const emptyObj = {};

class ProductListItemName extends React.PureComponent<
  ProductListItemNameProps,
  {}
> {
  /** We have a Babel transformation that takes classes
   * with only a render function, and turns them into functions
   * But this needs to be a class in order to have a ref
   */
  fakeProperty = () => 6;
  render() {
    const { isVerticallyCentered, text } = this.props;
    return (
      <div
        data-cypress="productName"
        style={isVerticallyCentered ? { textAlign: 'center' } : emptyObj}
      >
        {text}
      </div>
    );
  }
}

export default ellipsis(ProductListItemName, 2, ' ...');
